
import React from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search, UserPlus } from "lucide-react";

interface UserSearchBarProps {
  searchQuery: string;
  onSearchChange: (value: string) => void;
  onInviteUser: () => void;
}

const UserSearchBar: React.FC<UserSearchBarProps> = ({ 
  searchQuery, 
  onSearchChange, 
  onInviteUser 
}) => {
  return (
    <div className="flex justify-between items-center mb-6">
      <div className="relative">
        <Search className="absolute left-2.5 top-2.5 h-4 w-4 text-muted-foreground" />
        <Input
          type="search"
          placeholder="Search users..."
          className="pl-8 w-[250px]"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
        />
      </div>
      
      <Button variant="default" className="gap-2" onClick={onInviteUser}>
        <UserPlus className="h-4 w-4" />
        <span>Invite User</span>
      </Button>
    </div>
  );
};

export default UserSearchBar;
